import { render, staticRenderFns } from "./orgRegister.vue?vue&type=template&id=69f8f9d4"
import script from "./orgRegister.vue?vue&type=script&lang=js"
export * from "./orgRegister.vue?vue&type=script&lang=js"
import style0 from "./orgRegister.vue?vue&type=style&index=0&id=69f8f9d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports